module.exports = __webpack_public_path__ + "static/media/donbosco19.45313dcc.jpg";